import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { UserInformationState } from '../reducers/user-information.reducer';
import { Observable } from 'rxjs';
import { User } from '../../../user-management/users/user';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { getUserInformation, getUserInformationLoaded } from '../selectors';
import { LoadUserInformation } from '../actions';

@Injectable()
export class UserFacade {
  constructor(private store: Store<UserInformationState>) {}

  public getUserInformationFromStore(): Observable<User> {
    return this.checkUserInformationStore().pipe(
      switchMap(() => {
        return this.store.pipe(select(getUserInformation));
      })
    );
  }

  private checkUserInformationStore(): Observable<boolean> {
    return this.store.select(getUserInformationLoaded).pipe(
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(new LoadUserInformation());
        }
      }),
      filter((loaded: boolean) => loaded),
      take(1)
    );
  }
}
